import { cloneDeep } from "lodash"

/** 处理新增数据 */
export const handleAddData = (data) => {
  const newData = cloneDeep(data)
  /** 版本拼接成如下格式
   * app版本[格式6840-6937][与sdk版本必传其中一个],示例值(6840-6937)
  */
  if (newData.appVer || newData.appVerMax) {
    newData.appVer = newData.appVer + "-" + newData.appVerMax
  }
  delete newData.appVerMax
  if (newData.sdkVer || newData.sdkVerMax) {
    newData.sdkVer = newData.sdkVer + "-" + newData.sdkVerMax
  }
  delete newData.sdkVerMax
  /** 删除空的版本数据 */
  if (newData.appVer.length === 1 || newData.appVer === 0) {
    delete newData.appVer
  }
  if (newData.sdkVer.length === 1 || newData.sdkVer === 0) {
    delete newData.sdkVer
  }
  return newData
}